import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setFillablePDFsList } from '../store/fillablePDFs.actions'
export function* getPDFAttachments(pcrDoc: IPcr) {
  const { pdfAttachments } = pcrDoc
  if (pdfAttachments && pdfAttachments.length) {
    yield put(setFillablePDFsList(pdfAttachments))
  }
}
